import React, { useEffect, useState, useMemo, useCallback } from 'react'
import classes from './Stats2.module.css'
import usersIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/user.png'
import allSitesIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/home.png'
import OnlineIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/online.png'
import OfflineIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/offline.png'
import SpinnerIcon from '../../../assets/portalAssets/spinner.png'
import padlockIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/locks.png'
import gatewayIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/gateway.png'
import sensorIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/sensor.png'
import keyBoxesIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/keybox.png'
import unlinkedIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/unlinked.png'
import activeLock from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/activeLock.png'
import groupsIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/groups.png'
import usersIcon2 from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/user.png'
import IDIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/ID.png'
import portalNameIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/portalName.png'
import appNameIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/appName.png'
import firmwareIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/firmware.png'
import IPIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/ipIcon.png'
import macIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/mac.png'
import statusIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/status.png'
import suspendedIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/suspended.png'
import createdIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/created.png'
import cctvType from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/cctvType.png'
import deviceType from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/type.png'
import monitored from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/monitor.png'
import serial from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/serial.png'
import restriction from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/restriction.png'
import phoneIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/phone.png'
import activeIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/activeSidebar.png'
import inactiveIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/inactiveSidebar.png'
import origin from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/origin.png'
import usedBy from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/usedBy.png'
import ownedBy from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/ownedBy.png'
import billedTo from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/billedTo.png'
import battery from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/battery.png'
import master from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/master.png'
import timezone from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/world.png'
import billable from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/billedTo.png'
import deviceIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/deviceType.png'
import controllerIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/controller.png'
import empty from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/empty.png'
import lastloggedin from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/lastloggedin.png'
import cloud from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/cloud.png'
import enabled from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/bell.png'
import portalAdmin from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/adminStats.png'
import userSince from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/userSince.png'
import sitesOnSchedule from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/schedule.png'
import placeholder from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/placeholder.png'
import holidayIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/hmIcon.png'
import gatewayIconG from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/gatewayLogoPortalG.png'
import ajaxIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/ajaxLogoPortal.png'
import dahuaIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/dahuaLogoPortal.png'
import hikIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/hikLogoPortal.png'
import aiboxIcon from '../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/aiBoxLogoPortal.png'

import TimerIndicator from './Stats2/TimerIndicator'
import { Oval } from 'react-loading-icons'
import { useNavigate } from 'react-router-dom'
import DataManager from '../../../hooks/DataManager'
import { Dropdown } from 'primereact/dropdown'
import { Calendar } from 'primereact/calendar';
import { Button } from 'rsuite'
import { act } from 'react'


const Stats2 = ({ 
    title, 
    value, 
    status, 
    isLoadingStats, 
    isStatic, 
    changeNotifications, 
    setChangeNotifications, 
    changePortalAdmin, 
    setChangePortalAdmin, 
    setHolidayModeFilter, 
    allSitesFilter, 
    monitoredByOptions, 
    monitoredBy, 
    setMonitoredBy, 
    showMonitoredByDropdown, 
    setShowMonitoredByDropdown, 
    setShowChangeGroup, 
    setShowChangePortalName, 
    setShowChangeName, 
    setShowSuspendSite, 
    setShowChangeCCTV, 
    setMonitoringArc, 
    setShowChangeSerialNumber, 
    setChangePhoneNumber, 
    hasSecondValue, 
    value2, 
    setChangeUsername, 
    setChangeEmailAddress,
    setChangeLockName,
    setChangeBillable,
    setPINVisible,
    setChangeOwnedBy,
    setChangeBilledTo,
    setNavigateToLinkedSite,
    setNavigateToGroup,
    isAllowedToChange,
    setUnauthorisedClick
}, props) => {

    const dataManager = new DataManager()
    const [isMoblie, setIsMoblie] = useState(false)
    const [cssClass, setCssClass] = useState({ stroke: "var(--Primary-Color2)", height: 47.5, speed: 1.5 });
    const navigate = useNavigate();

    useEffect(() => {
        const mediaQuery = window.matchMedia('(max-width: 430px)'); // Define your media query here

        // Function to handle changes in the media query
        const handleIsMobile = () => {
            if (window.innerWidth <= 430) {
                setIsMoblie(true)

            } else {
                setIsMoblie(false)
            }
        };

        // Initial check for if screen has been resized
        handleIsMobile(mediaQuery);

        // Add event listener for changes in the media query
        mediaQuery.addListener(handleIsMobile);

        // Clean up by removing event listener when component unmounts
        return () => {
            mediaQuery.removeListener(handleIsMobile);
        };
    }, []);

    useEffect(() => {
        if (!isMoblie) {
            setCssClass({ stroke: "var(--Primary-Color)", height: 47.5, speed: 1.5 });
        } else if (isMoblie) {
            setCssClass({ stroke: "var(--Primary-Color)", height: 30, speed: 1.5 });
        }
    }, [isMoblie]);

    const handleOfflineSitesClick = () => {
        navigate("/Dashboard/Offline");
    };
    const handleOnlineSitesClick = () => {
        navigate("/Dashboard/AllSites");
    };
    const handleUsersClick = () => {
        navigate("/Dashboard/Users");
    };
    const handlePadlocksClick = () => {
        navigate("/Dashboard/Padlocks");
    };
    const handleKeyboxesClick = () => {
        navigate("/Dashboard/Keyboxes");
    };
    const handleSensorsClick = () => {
        navigate("/Dashboard/Sensors");
    };
    const handleGatewaysClick = () => {
        navigate("/Dashboard/Gateways");
    };
    const handleAccountsClick = () => {
        navigate("/Dashboard/Groups");
    };
    const handleActiveSitesClick = () => {
        navigate("/Dashboard/ActiveSites")
    }
    const handleEmptySitesClick = () => {
        navigate("/Dashboard/InactiveSites")
    }
    const handleControllersClick = () => {
        navigate("/Dashboard/Controllers");
    };
    const handleChangeNotifications = () => {
        setChangeNotifications(true);
    }
    const handleChangePortalAdmin = () => {
        setChangePortalAdmin(true);
    }
    const handleSitesOnScheduleClick = () => {
        navigate("/Dashboard/ScheduledActions");
    }
    const handleWithHolidayModeClick = () => {
        setHolidayModeFilter();
    }
    const handleTotalSitesOnScheduleClick = () => {
        allSitesFilter();
    }
    const handleIntegrationClick = () => {
        navigate("/Dashboard/CCTVIntegrations")
    }

    const showMonitoredBy = () => {
        //TEMP REMOVAL
        setShowMonitoredByDropdown(true)
    }

    const handleSetMonitoredBy = (e) => {
        setMonitoringArc(e.id, e.name)
        setShowMonitoredByDropdown(false)
    }

    let specialClasses = null;
    let icon;

    if (title === 'Total users' || title === "Users" || title === "Total portal users") {
        specialClasses = classes.users;
        icon = usersIcon;
    }
    if (title === 'Online sites' || title === 'Online controllers') {
        specialClasses = classes.devicesOnline;
        icon = OnlineIcon;
    }
    if (title === 'Offline sites' || title === 'Offline controllers' || title === 'Offline controllers ' || title === 'Total offline controllers' ) {
        specialClasses = classes.devicesOffline;
        icon = OfflineIcon;
    }
    if (title === "Total padlocks" || title === "Padlocks"){
        specialClasses = classes.totalCount;
        icon = padlockIcon;
    }
    if (title === "Total sensors"|| title === "Sensors"){
        specialClasses = classes.totalCount;
        icon = sensorIcon;
    }
    if (title === "Total keyboxes" || title === "Keyboxes"){
        specialClasses = classes.totalCount;
        icon = keyBoxesIcon;
    }
    if (title === "Total groups" || title === "Groups"){
        specialClasses = classes.totalCount;
        icon = groupsIcon;
    }
    if (title === "Total active users" || title === 'Controllers with no users'){
        specialClasses = classes.totalCount;
        icon = usersIcon;
    }
    if (title === 'Total sites'|| title === "All sites") {
        specialClasses = classes.totalCount;
        icon = allSitesIcon;
    }
    if (title === 'All controller count' || title === "Controllers"){
        specialClasses = classes.totalCount;
        icon = controllerIcon;
    }
    if (title === 'Total groups') {
        specialClasses = classes.totalCount;
        icon = groupsIcon;
    }
    if (title === "Offline for more than 1 month"){
        specialClasses = classes.devicesOffline;
        icon = OfflineIcon
    }
    if (title === "Offline for less than 1 month"){
        specialClasses = classes.devicesOffline;
        icon = OfflineIcon
    }
    if (title === "Active offline controllers"){
        specialClasses = classes.devicesOffline;
        icon = OfflineIcon
    }
    if (title === "Inactive sites"){
        specialClasses = classes.inactiveCount;
        icon = inactiveIcon
    }
    if (title === "Active sites"){
        specialClasses = classes.activeCount;
        icon = activeIcon
    }
    if (title === "Name" ){
        specialClasses = classes.modifiable;
        icon = usersIcon2
    }
    if (title === "Registered by"){
        specialClasses = classes.name;
        icon = usersIcon2
    }
    if (title === "Email address"){
        specialClasses = classes.modifiable;
        icon = usersIcon
    }
    if (title === "Last logged in" || title === "Last updated" ){
        specialClasses = classes.name;
        icon = lastloggedin
    }
    if (title === "Notifications"){
        specialClasses = classes.modifiable;
        icon = enabled
    }
    if (title === "User since" || title === "Registration date"){
        specialClasses = classes.name;
        icon = userSince
    }
    if (title === "App admin"){
        specialClasses = classes.modifiable;
        icon = portalAdmin
    }
    if (title === "Gateways" || title === "Total gateways"){
        specialClasses = classes.totalCount;
        icon = gatewayIconG
    }
    if (title === "Total access"){
        specialClasses = classes.totalAccess;
        icon = allSitesIcon
    }
    if (title === "Physical controllers"){
        specialClasses = classes.physicalController;
        icon = controllerIcon
    }
    if (title === "Cloud controllers"){
        specialClasses = classes.cloudController;
        icon = cloud
    }
    if (title === "Scheduled sites" || title == "Sites on schedule"){
        specialClasses = classes.cloudController;
        icon = sitesOnSchedule
    }
    if (title === "with temporary schedules"){
        specialClasses = classes.withHolidayMode;
        icon = holidayIcon
    }

    if (title === "Total sites on schedule"){
        specialClasses = classes.cloudController;
        icon = sitesOnSchedule
    }

    if (title === "Lock ID"){
        specialClasses = classes.name
        icon = IDIcon
    }
    if (title === "Timezone"){
        specialClasses = classes.name
        icon = timezone
    }
    if (title === "Lock name"){
        //clickable
        specialClasses = classes.modifiable
        icon = portalNameIcon
    }
    if (title === "Linked to" || title === "Output"){
        specialClasses = classes.overviewDefaultClickable
        icon = allSitesIcon
    }
    if (title === "Output") {
        specialClasses = classes.overviewDefaultClickable
        icon = padlockIcon
    }
    if (title === "Master PIN"){
        specialClasses = classes.nameRed
        icon = master
    }
    if (title === "Battery"){
        specialClasses = classes.name
        icon = battery
    }
    if (title === "Billable"){
        specialClasses = classes.modifiable
        icon = billable
    }
    if (title === "Used by"){
        specialClasses = classes.overviewDefaultClickable
        icon = usedBy
    }
    if (title === "Owned by"){
        specialClasses = classes.modifiable
        icon = ownedBy
    }
    if (title === "Billed to"){
        specialClasses = classes.modifiable
        icon = billedTo
    }
    //Site Overview
    if (title === "Group"){
        specialClasses = classes.overviewDefaultClickable;
        icon = groupsIcon
    }
    if (title === "Site ID"){
        specialClasses = classes.overviewDefault;
        icon = IDIcon
    }
    if (title === "Portal site name"){
        specialClasses = classes.overviewDefaultClickable;
        icon = portalNameIcon
    }
    if (title === "My app site name"){
        specialClasses = classes.overviewDefaultClickable;
        icon = appNameIcon
    }
    if (title === "Firmware"){
        specialClasses = classes.overviewDefault;
        icon = firmwareIcon
    }
    if (title === "Site type"){
        specialClasses = classes.overviewDefault;
        icon = deviceType
    }
    if (title === "IP address"){
        specialClasses = classes.overviewDefault;
        icon = IPIcon
    }
    if (title === "MAC address"){
        specialClasses = classes.overviewDefault;
        icon = macIcon
    }
    if (title === "Status"){
        specialClasses = classes.overviewDefault;
        icon = statusIcon
    }
    if (title === "Suspended"){
        specialClasses = classes.overviewDefaultClickable;
        icon = suspendedIcon
    }
    if (title === "Offline since"){
        specialClasses = classes.overviewDefault;
        icon = placeholder
    }
    if (title === "Created"){
        specialClasses = classes.overviewDefault;
        icon = createdIcon
    }
    if (title === "CCTV integration type"){
        specialClasses = classes.overviewDefaultClickable;
        icon = cctvType
    }
    if (title === "Monitored by"){
        specialClasses = classes.overviewDefaultClickable;
        icon = monitored
    }

    if (title === "Access restrictions"){
        specialClasses = classes.overviewDefault;
        icon = restriction
    }

    if (title === "Serial number"){
        specialClasses = classes.overviewDefaultClickable;
        icon = serial
    }
    if (title == "Unlinked padlocks"){
        specialClasses = classes.unlinkedCount;
        icon = unlinkedIcon;
    }
    if (title == "Unlinked keyboxes"){
        specialClasses = classes.unlinkedCount;
        icon = unlinkedIcon;
    }
    if (title == "Phone number"){
        specialClasses = classes.modifiable
        icon = phoneIcon
    }


    if (title == "Total integrations"){
        icon = cctvType
        specialClasses = classes.totalIntegrations
    }
    if (title == "AJAX") {
        icon = ajaxIcon
        specialClasses = classes.ajax
    }
    if (title == "Hikvision"){
        icon = hikIcon
        specialClasses = classes.hikvision
    }
    if (title == "Dahua"){
        icon = dahuaIcon
        specialClasses = classes.dahua
    }
    if (title == "AIBox"){
        icon = aiboxIcon
        specialClasses = classes.aibox
    }
    if (title == "Origin"){
        specialClasses = classes.name;
        icon = origin
    }
    if (title === "Billable padlocks" || title === "Billable keyboxes"){
        specialClasses = classes.totalCount;
        icon = billable
    }
    if (title === "Device type"){
        specialClasses = classes.name;
        icon = deviceIcon
    }
    if (title === "Padlocks on active sites"){
        specialClasses = classes.devicesOnline;
        icon = activeLock
    }
    if (title === "Keyboxes on active sites"){
        specialClasses = classes.devicesOnline;
        icon = activeLock
    }

    if (title === "Billable padlocks " || title === "Billable keyboxes "){
        specialClasses = classes.totalCount;
        icon = billable
    }



    const cssClasses = `${classes['Top-left']} ${specialClasses}`;

    const changeGroup = () => {
        setShowChangeGroup(true)
    }

    const changePortalName = () => {
        setShowChangePortalName(true)
    }

    const changeAppName = () => {
        setShowChangeName(true)
    }

    const changeSuspendedStatus = () => {
        setShowSuspendSite(true)
    }

    const changeCCTVIntegrationType = () => {
        if(value == "Whole camect" || value == "Per camera arming"){ //TODO - change this to check if it should be enabled by RE:SURE instead
           setShowChangeCCTV(true) 
        }
    }

    const setSerialNumber = () => {
        setShowChangeSerialNumber(true)
    }

    const setPhoneNumber = () => {
        setChangePhoneNumber(true)
    }

    const setUsername = () => {
        setChangeUsername(true)
    }

    const setEmailAddress = () => {
        setChangeEmailAddress(true)
    }

    const setShowChangeLockName = () => {
        setChangeLockName(true)
    }

    const changeOwnedBy = () => {
        setChangeOwnedBy(true)
    }

    const changeBilledTo = () => {
        setChangeBilledTo(true)
    }

    const navigateToLinkedSite = () => {
        setNavigateToLinkedSite(true)
    }

    const navigateToGroup = () => {
        setNavigateToGroup(true)
    }

    const changeBillable = () => {
        if (isAllowedToChange){
            setChangeBillable(true)
        } else {
            setUnauthorisedClick(true)
        }
    }

return (
  <div
    className={`${classes.container} ${props.container}`}
    {...(title === 'Offline sites' || title === 'Offline controllers' ? { onClick: handleOfflineSitesClick} : {})}
    {...(title === 'Online sites' ? { onClick: handleOnlineSitesClick } : {})}
    {...(title === 'All sites' ? { onClick: handleOnlineSitesClick } : {})}
    {...(title === 'Users' ? { onClick: handleUsersClick } : {})}
    {...(title === 'Padlocks' ? { onClick: handlePadlocksClick } : {})}
    {...(title === 'Sensors' ? { onClick: handleSensorsClick } : {})}
    {...(title === 'Gateways' ? { onClick: handleGatewaysClick } : {})}
    {...(title === 'Keyboxes' ? { onClick: handleKeyboxesClick } : {})}
    {...(title === 'Groups' ? { onClick: handleAccountsClick } : {})}
    {...(title === 'Active sites' ? { onClick: handleActiveSitesClick } : {})}
    {...(title === 'Inactive sites' ? { onClick: handleEmptySitesClick } : {})}
    {...(title === 'Controllers' ? { onClick: handleControllersClick } : {})}
    {...(title === 'Notifications' ? { onClick: handleChangeNotifications } : {})}
    {...(title === 'App admin' ? { onClick: handleChangePortalAdmin } : {})}
    {...(title === 'Sites on schedule' ? { onClick: handleSitesOnScheduleClick} : {})}

    {...(title === 'Total sites on schedule' ? { onClick: handleTotalSitesOnScheduleClick} : {})}
    {...(title === 'with temporary schedules' ? { onClick: handleWithHolidayModeClick} : {})}
    {...(title === 'Scheduled sites' ? { onClick: handleSitesOnScheduleClick} : {})}
    {...(title === 'Monitored by' ? { onClick: showMonitoredBy } : {})}
    {...(title === 'Group' ? { onClick: changeGroup } : {})}
    {...(title === 'Portal site name' ? { onClick: changePortalName } : {})}
    {...(title === 'My app site name' ? { onClick: changeAppName } : {})}
    {...(title === 'Suspended' ? { onClick: changeSuspendedStatus } : {})}
    {...(title === 'CCTV integration type' ? { onClick: changeCCTVIntegrationType } : {})}
    {...(title === 'Serial number' ? { onClick: setSerialNumber } : {})}
    {...(title === 'Phone number' ? { onClick: setPhoneNumber } : {})}
    {...(title === 'Name' ? { onClick: setUsername } : {})}
    {...(title === 'Email address' ? { onClick: setEmailAddress } : {})}
    {...(title === 'Total integrations' 
            || title == "AJAX" 
            || title == "Hikvision" 
            || title == "Dahua" 
            || title == "AIBox" ? { onClick: handleIntegrationClick } : {})}
    {...(title === 'Lock name' ? { onClick: setShowChangeLockName } : {})}
    {...(title === 'Billable' ? { onClick: changeBillable } : {})}
    {...(title === "Master PIN"
        ? {
            onMouseDown: () => setPINVisible(true),
            onMouseUp: () => setPINVisible(false),
            onMouseLeave: () => setPINVisible(false), // in case they drag off
            onTouchStart: () => setPINVisible(true),
            onTouchEnd: () => setPINVisible(false),
            }
        : {})}
    {...(title === 'Owned by' ? { onClick: changeOwnedBy } : {})} 
    {...(title === 'Billed to' ? { onClick: changeBilledTo } : {})} 
    {...(title === 'Linked to' || title === "Output" ? { onClick: navigateToLinkedSite } : {})} 
    {...(title === 'Used by' ? { onClick: navigateToGroup } : {})} 

  >
    <div className={classes["Top"]}>
      <h3>{title}</h3>
      {!isStatic && <TimerIndicator className={classes["TimeStatus-component"]} status={status} />}
    </div>

    <div className={classes["Bottom"]}>
      <div className={cssClasses}>
        {isLoadingStats ? (
          <Oval stroke={cssClass.stroke} height={cssClass.height} speed={cssClass.speed} />
        ) : (
            <div className={classes.headingWithSmall}>
                <h1>{value}</h1>
                { hasSecondValue && <small>{`(${value2} active)`}</small>}
            </div>
        )}
      </div>
      {title === "Email address" && <div className={classes.icon} />}
      {title !== "Email address" && <img className={classes.icon} alt={`${title} icon`} src={icon} />}
    </div>

    {title === "Notifications" && (
      <div className={classes.activeSites}>
        <p>{value == "Enabled" ? "Click to disable notifications" : "Click to enable notifications" }</p>
      </div>
    )}

    {title === "App admin" && (
      <div className={classes.activeSites}>
        <p>{value == "Yes" ? "Click to disable app admin" : "Click to enable app admin" }</p>
      </div>
    )}

    {title === "Phone number" && (
      <div className={classes.activeSites}>
        <p>{"Click to edit phone number"}</p>
      </div>
    )}

    {title === "Name" && (
      <div className={classes.activeSites}>
        <p>{"Click to edit name"}</p>
      </div>
    )}

    {title === "Email address" && (
      <div className={classes.activeSites}>
        <p>{"Click to edit email address"}</p>
      </div>
    )}

    {(
        title === "All controller count" ||
        title === "Total offline controllers" ||
        title === "Active offline controllers" ||
        title === "Offline for less than 1 month" ||
        title === "Offline for more than 1 month" ||
        title === "Online controllers" ||
        title === "Controllers with no users" || 
        title === "with temporary schedules" ||
        title === "Total sites on schedule"
    ) && (
        <div className={classes.activeSites}>
            <p>Click to apply filter</p>
        </div>
    )}

    { title === "Offline controllers " && (
         <div className={classes.activeSites}>
            <p>Click to view</p>
        </div>
    )}

    { title === "Master PIN" && (
         <div className={classes.activeSites}>
            <p>Click and hold to view</p>
        </div>
    )}

    {title === "Lock name" && (
         <div className={classes.activeSites}>
            <p>Click to edit</p>
        </div>
    )}

    {title === "Billable" && (
         <div className={classes.activeSites}>
            <p>Click to edit</p>
        </div>
    )}

    {title === "Owned by" && (
         <div className={classes.activeSites}>
            <p>Click to edit</p>
        </div>
    )}

    {title === "Billed to" && (
         <div className={classes.activeSites}>
            <p>Click to edit</p>
        </div>
    )}

    {title === "Billable padlocks" && (
        <div className={classes.activeSites}>
            <small>On active sites billed to this group </small>
        </div>
    )}

    { title === "Billable keyboxes" && (
        <div className={classes.activeSites}>
            <small>On active sites billed to this group</small>
        </div>
    )}


    {title === "Monitored by" && showMonitoredByDropdown && (
      <div onClick={(e) => e.stopPropagation()}>
        <Dropdown 
          value={monitoredBy} 
          onChange={(e) => handleSetMonitoredBy(e.value)}
          options={monitoredByOptions}
          optionLabel="name"
          placeholder="Select an option" 
          className="w-full md:w-14rem" 
        />
      </div>
    )}

    {title === "Empty sites" && (
      <div className={classes.activeSites}>
        <p>Online sites with 0 users & no portal name</p>
      </div>
    )}
  </div>
);

}


export default Stats2;